import { FC } from 'react'
import styled from 'styled-components'
import { LandingPage } from '@/network/graphql.g'
import { Flex } from '@/components/atoms/Grid'
import { H1 } from '@/components/atoms/typography'
import { validFor } from '@/theme/validFor'

type BlackFridayHeaderProps = {
  landingPage: LandingPage
}

const BlackFridayHeader: FC<BlackFridayHeaderProps> = ({ landingPage }) => {
  return (
    <Flex flexDirection="column" alignItems="center" width="100%" mb={3}>
      <StyledH1>{landingPage.name}</StyledH1>
    </Flex>
  )
}

export default BlackFridayHeader

const StyledH1 = styled(H1)`
  text-transform: uppercase;
  margin: 30px 0 6px 0;
  ${validFor.mobile`
    font-size: 28px;
  `}
`
